import { BackendFilter } from "./sessions"

export type SavedView = {
    view_id: string
    user_id: string
    team_id: string
    name: string
    is_team: boolean
    filter: BackendFilter
}

export function jsonSafeToSavedView(json: Record<string, any>): SavedView {
    return {
        view_id: json.view_id,
        user_id: json.user_id,
        team_id: json.team_id,
        name: json.name,
        is_team: json.is_team,
        filter: JSON.parse(json.filter_str),
    }
}

export function jsonSafeToSavedViewList(json: Record<string, any>): SavedView[] {
    return json.map((item: Record<string, any>) => jsonSafeToSavedView(item))
}